"use client";

import PartnerSignupForm from "./PartnerSignupForm";
import Icon from "@/components/ui/AppIcon";

export default function PartnerSignupContent() {
  return (
    <>
      {/* Page Header */}
      <section className="py-24 px-6 border-b border-white/5">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <Icon name="UserGroupIcon" size={48} className="text-blue-400" />
            <h1 className="text-5xl md:text-6xl font-bold text-white">
              Partner Architect Network
            </h1>
          </div>
          <p className="text-xl text-neutral-400 mb-8 max-w-3xl mx-auto">
            Join our network of integration partner architects. Applications are
            reviewed by our expert team to ensure partnership eligibility.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-neutral-500">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={20} className="text-emerald-400" />
              <span>Expert Validation</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="ShieldCheckIcon" size={20} className="text-blue-400" />
              <span>Verified Partners</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="StarIcon" size={20} className="text-amber-400" />
              <span>Exclusive Network</span>
            </div>
          </div>
        </div>
      </section>

      {/* Signup Form */}
      <section className="py-24 px-6">
        <PartnerSignupForm />
      </section>

      {/* Benefits Section */}
      <section className="py-12 px-6 border-t border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">
            Partnership Benefits
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="glass-card rounded-2xl p-6">
              <Icon name="BriefcaseIcon" size={32} className="text-blue-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">
                Project Opportunities
              </h3>
              <p className="text-neutral-400">
                Access to enterprise integration projects across multiple
                industries and ERP platforms.
              </p>
            </div>
            <div className="glass-card rounded-2xl p-6">
              <Icon name="AcademicCapIcon" size={32} className="text-emerald-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">
                Knowledge Sharing
              </h3>
              <p className="text-neutral-400">
                Collaborate with expert architects and stay updated on best
                practices and emerging patterns.
              </p>
            </div>
            <div className="glass-card rounded-2xl p-6">
              <Icon name="SparklesIcon" size={32} className="text-amber-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">
                Brand Recognition
              </h3>
              <p className="text-neutral-400">
                Featured in our partner directory with verified architect status
                and credentials.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Validation Process */}
      <section className="py-12 px-6 border-t border-white/5">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">
            Validation Process
          </h2>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500/20 border border-blue-500/30 flex items-center justify-center text-blue-400 font-bold">
                1
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  Application Submission
                </h3>
                <p className="text-neutral-400">
                  Submit your application with credentials, experience, and
                  specializations.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500/20 border border-blue-500/30 flex items-center justify-center text-blue-400 font-bold">
                2
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  Expert Review
                </h3>
                <p className="text-neutral-400">
                  Our team of senior architects reviews your qualifications and
                  validates your experience.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500/20 border border-blue-500/30 flex items-center justify-center text-blue-400 font-bold">
                3
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  Partnership Approval
                </h3>
                <p className="text-neutral-400">
                  Approved partners receive onboarding materials and access to
                  the partner portal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}